import { FC } from "react";
import { cn } from "@/libs/utils";
import ReactPaginate from "react-paginate";
import ChevronLeftIcon from "@/v2-components/core/icon/chevron-left-icon";
import ChevronRightIcon from "@/v2-components/core/icon/chevron-right-icon";
type Props = {
  currentPage: number;
  className?: string;
  onUpdate: (to: number) => void;
  pageCount: number;
};

const Chevron = (props: any) => (
  <div
    className={cn(
      props.direction === "left" ? "mr-5" : "ml-5",
      "flex h-[3.125rem] w-[3.125rem] items-center justify-center bg-[#222222]",
    )}
  >
    {props.children}
  </div>
);

const Paginate: FC<Props> = ({
  currentPage,
  pageCount,
  className = "",
  onUpdate,
}) => {
  return (
    <div
      className={cn(
        className,
        "my-12 flex h-12 items-center justify-center sm:my-20",
        "[&>ul:first-of-type]:flex [&>ul:first-of-type]:h-[3.125rem] [&>ul:first-of-type]:items-center [&>ul:first-of-type]:pl-0",
        "[&>ul:first-of-type>li]:cursor-pointer [&>ul:first-of-type>li]:opacity-50",
        "[&>ul:first-of-type>li.next]:opacity-100 [&>ul:first-of-type>li.previous]:opacity-100",
        "[&>ul:first-of-type>li.next:hover]:opacity-75 [&>ul:first-of-type>li.previous:hover]:opacity-75",
        "[&>ul:first-of-type>li:hover]:opacity-100",
        "[&>ul:first-of-type>li.selected]:pointer-events-none [&>ul:first-of-type>li.selected]:opacity-100",
        "[&>ul:first-of-type>li.disabled]:pointer-events-none [&>ul:first-of-type>li.disabled]:opacity-50",
        "[&>ul:first-of-type>li:not(.previous):not(.next)]:flex [&>ul:first-of-type>li:not(.previous):not(.next)]:text-sm",
        "[&>ul:first-of-type>li:not(.previous):not(.next)]:items-center [&>ul:first-of-type>li:not(.previous):not(.next)]:justify-center",
        "[&>ul:first-of-type>li:not(.previous):not(.next)]:w-10",
      )}
    >
      <ReactPaginate
        previousLabel={
          <Chevron direction={"left"}>
            <ChevronLeftIcon className="text-white" />
          </Chevron>
        }
        nextLabel={
          <Chevron direction={"right"}>
            <ChevronRightIcon className="text-white" />
          </Chevron>
        }
        activeLinkClassName={"font-700"}
        pageRangeDisplayed={3}
        marginPagesDisplayed={1}
        pageCount={pageCount}
        pageLinkClassName={"p-3"}
        onPageChange={(change: { selected: number }) => {
          onUpdate(change.selected + 1);
        }}
      />
    </div>
  );
};

export default Paginate;
